export default "__VITE_ASSET__BqKKpXGc__"